<template>
  <div class="cp-article-borderless" @click="$emit('click')">
    <img class="cp-article-borderless-image" :src="image" />
    <div class="cp-article-borderless-black-tab gf"
      :class="{activeClass : type}"
    ></div>
    <div class="cp-article-borderless-detail">
      <p :class="['cp-article-borderless-title',
      'is-size-5', 'has-text-link', 'has-text-left',
      {specialFont : type}]">
        {{ title }}
      </p>
      <p
        :class="['cp-article-borderless-excerpt', 'has-text-white',
        'is-size-8', 'has-text-grey-dark', 'has-text-left']"
      >
        {{ excerpt }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArticleBorderless',
  props: {
    title: {
      type: String,
      required: true,
    },
    excerpt: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    type: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
$image-height: 180px;
$title-height: 50px;
$excerpt-height: 70px;
$see-more-height: 15px;
.activeClass{
  height: 25% !important;
}
.specialFont{
  font-size: 2.5rem !important;
}
.cp-article-borderless {
    overflow: hidden;
    width: 100%;
    position: relative;
  // width: 280px;
  // margin-top: 20px;
     cursor: pointer;
  // overflow: hidden;
  // display: inline-block;
  // vertical-align: middle;
  // margin: 10px;
  // margin-left: 2px;
  // background-color: white;
  // top: 0px;
  // position: relative;
  // transition: top 0.1s ease-out, box-shadow 0.1s ease-out;

  &-black-tab {
    position: absolute;
    width: 100%;
    height: 40%;
    background: -moz-linear-gradient(top,transparent 0%,transparent 1%,rgba(0,0,0,0.78) 100%);
    background: -webkit-linear-gradient(top,transparent 0%,transparent 1%,rgba(0,0,0,0.78) 100%);
    background: black;
    opacity: 0.5;
    z-index: 5;
    bottom: 0;
  }

  &-image-container {
    height: $image-height;
  }

  &-image {
    // max-height: $image-height;
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }

  &-detail {
    position: absolute;
    width: 100%;
    z-index: 9;
    padding: 10px;
    bottom: 0;
  }

  &-title {
    color: white !important;
    font-weight: bold;
  }

  &-excerpt {
    color: white !important;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    overflow: hidden;
    white-space: nowrap;
  }
  &-divider {
    margin-left: auto;
    margin-right: auto;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  &-see-more {
    height: $see-more-height;
  }
}
</style>
